const endpoints = {
  auth: {
    login: "/vendors/login/",
    logout: "/users/logout",
    refreshToken: "/users/refresh-token",
    register: "/vendors/signup/",
    vendorcategory: "/admin-panel/app-options/list",
    resetpassword: "/admin-panel/forgot-password/reset",
    sendotp: "/admin-panel/forgot-password/send-otp",
    verifyotp: "/admin-panel/forgot-password/verify-otp",
    changepassword: "/vendors/profile/change-password/",
    twofactorauthentication: "/vendors/login/verify-2fa/",
  },
  changePassword: {
    sendOtp: "/admin-panel/change-password/send-otp",
    verifyOtp: "/admin-panel/change-password/verify-otp",
    reset: "/admin-panel/change-password/reset",
  },
  location: {
    countries: "/users/countries",
    states: (countryId) => `/users/states/${countryId}`,
    cities: (countryId, stateId) =>
      `/users/cities/${countryId}?state_id=${stateId}`,
  },

  dashboard: {
    venuedashboard: "/vendors/dashboard/",
    eventdashboard: "/vendors/events/dashboard/",
  },

  proposals: {
    list: "/vendors/venues/proposals/",
    detail: (id) => `/vendors/venues/proposals/${id}/`,
    reject: (id) => `/vendors/venues/proposals/${id}/reject/`,
    quotation: (id) => `/vendors/venues/proposals/${id}/quotation/`,
  },

  venueprofile: {
    profile: "/vendors/profile/",
    profileEdit: "/vendors/profile/",
  },

  mylisting: {
    list: "/vendors/venues/listings/",
    stats: "/vendors/venues/stats/",
    listingDetailstats: (id) => `/vendors/venues/detail/${id}/stats/`,
    listingDetail: (id) => `/vendors/venues/detail/${id}/`,
    createlisting: "/vendors/venues/create/",
    vendorcategory: "/vendors/venues/categories/",
    amenities: "/vendors/venues/amenities/",
    updatelisting: (id) => `/vendors/venues/update/${id}/`,
    eventlisting: "/vendors/venues/events/",
    history: (venueId) => `/history/venue/${venueId}`,
  },

  venuebookings: {
    list: "/vendors/venues/booking-lists/",
    export: "/vendors/venues/booking-lists/?export=true",
    stats: "/vendors/venues/bookings/stats/",
    detail: (id) => `/vendors/venues/bookings/${id}/`,
    contract: (id) => `/vendors/venues/bookings/${id}/contract/`,
    invoice: (id) => `/vendors/venues/bookings/${id}/invoice/`,
    proposal: (id) => `/vendors/venues/bookings/${id}/proposal/`,
    markCash: (id) => `/vendors/venues/bookings/${id}/payments/mark-cash/`,
  },

  negotiations: {
    list: "/vendors/venues/negotiations/",
    stats: "/vendors/venues/negotiations/stats/",
    messages: (id) => `/vendors/venues/negotiations/${id}/messages/`,
    quotation: (id) => `/vendors/venues/negotiations/${id}/quotation/`,
    messagesByUser: (userId) =>
      `/vendors/venues/negotiations/user/${userId}/messages/`,
  },

  setting: {
    languageslist: "/users/languages",
    currencieslist: "/users/currencies",
    preferences: "/vendors/preferences/",
    updatepreferences: "/vendors/preferences/",
  },

  eventmanagement: {
    categorylist: "/vendors/events/categories/",
    subcategorylist: (id) => `/vendors/events/categories/${id}/subcategories/`,
    createEvent: "/vendors/events/",
    eventDetail: (id) => `/vendors/events/${id}/`,
    eventUpdate: (id) => `/vendors/events/${id}/`,
    amenities: "/vendors/events/amenities/",
    ticektTypes: "/vendors/events/ticket-types/",
    history: (eventId) => `/history/event/${eventId}`,
  },

  coupons: {
    create: "/vendors/coupons/",
    detail: (id) => `/vendors/coupons/${id}`,
    update: (id) => `/vendors/coupons/${id}`,
    delete: (id) => `/vendors/coupons/${id}`,
    toggleStatus: (id) => `/vendors/coupons/${id}/toggle-status`,
  },

  events: {
    list: "/vendors/events/",
  },

  eventbookings: {
    list: "/admin-panel/bookings/booking-list",
    listByEvent: (eventId) =>
      `/admin-panel/bookings/booking-list?booking_type=event&event_id=${eventId}`,
    bookingDetail: (id) => `/admin-panel/bookings/booking-detail/${id}`,
    attendees: "/vendors/events/bookings/attendees/",
    checkIn: "/vendors/events/bookings/checkins/",
    refunds: "/vendors/events/refund_requests/",
    downloadTicket: (id) => `/admin-panel/bookings/booking-detail/${id}/ticket`,
    downloadInvoice: (id) =>
      `/admin-panel/bookings/booking-detail/${id}/invoice`,
  },

  hotel: {
    createHotel: "/vendors/hotels/hotel/",
    updateHotel: (hotelId) => `/vendors/hotels/hotel/${hotelId}/`,
    getForEdit: (hotelId) => `/vendors/hotels/hotel/get/${hotelId}/`,
    tax: "/hotels/hotel/tax/",
    amenities: "/hotels/hotel/amenities/",
    attractions: "/hotels/hotel/attractions/",
    propertyType: "/hotels/hotel/property-dropdown/",
    room: "/hotels/hotel/room-dropdown/",
    hotelHistory: (hotelId) => `/history/hotel/${hotelId}`,
  },

  events: {
    list: "/vendors/events/",
  },
  hotelcustomer: {
    dashboard: "/vendors/hotel_customer/dashboard",
    list: "/vendors/hotel_customer/list",
  },
  hotelcancellation: {
    list: "/vendors/hotel-cancellation-policy/policy/",
    create: "/vendors/hotel-cancellation-policy/policy/",
    detail: (policyId) =>
      `/vendors/hotel-cancellation-policy/policy/${policyId}/`,
    update: (policyId) =>
      `/vendors/hotel-cancellation-policy/policy/${policyId}/`,
    delete: (policyId) =>
      `/vendors/hotel-cancellation-policy/policy/${policyId}/`,
  },
  // hotelRating: {
  //   list: "/bookings/rating/stats/vendor/overall/hotel/",
  //   hotelrate: "/bookings/rating/summary/vendor/overall/hotel/",
  //   reply: (ratingId) => `/bookings/rating/${ratingId}/reply/`,
  // },
  hotelReport: {
    list: "/vendors/hotels/reports/",
  },
  hoteldashboard: {
    list: "/vendors/hotel-dashboard/list",
    dashboard: "/vendors/hotel-dashboard/dashboard",
  },
  hotelportal: {
    list: "/vendors/hotel-portal/list",
    details: (hotelId) => `/vendors/hotel-portal/details/${hotelId}`,
  },
  notifications: {
    notifications: "/notifications/",
  },
  hotelBooking: {
    bookings: "/vendors/hotel-bookings/list",
    detail: (bookingId) => `/vendors/hotel-bookings/detail/${bookingId}`,
  },
  hotelprofile: {
    profile: "/vendors/profile/",
    profileEdit: "/vendors/profile/",
  },

  changeRequests: {
    list: "/change-requests/",
    create: "/change-requests/",
    detail: (id) => `/change-requests/${id}/`,
    requestTypes: "/change-requests/request-types/",
    listings: "/change-requests/listings/",
    conversations: (id) => `/change-requests/${id}/conversations/`,
  },

  earning: {
    graph: "/vendors/earnings-dashboard/",
    card: "/vendors/earnings-dashboard/stats/",
    transaction: "/vendors/earnings-dashboard/transactions/",
  },
  notification: {
    list: "/notifications/",
    read: (id) => `/notifications/${id}/read/`,
    markAllRead: "/notifications/mark-all-read/",
    delete: (id) => `/notifications/${id}/delete/`,
  },

  rating: {
    rating: "/bookings/rating-summary",
    review: "/bookings/rating/review",
    reply: (id) => `bookings/rating/${id}/reply/`,
  },
  holidaypackage: {
    list: "/vendors/packages/package/",
    detail: (id) => `/vendors/packages/package/${id}/`,
    cards: "/vendors/packages/package/overview/",
    categories: "/admin-panel/packages/package/category/",
    delete: (id) => `/vendors/packages/package/${id}/`,
    city: "/hotels/hotel/city/suggestion/",
    roomsdropdown: "/hotels/hotel/room-dropdown/",
    flightairport: "/flights/airports",
    airline: "/admin-panel/price-lock/airlines",
    create: "/vendors/packages/package/",
    update: (id) => `/vendors/packages/package/${id}/`,
    changestatus: (id) => `/vendors/packages/package/${id}/status/`,
    booking: "/vendors/packages/package/bookings/",
    bookingcancel:"/vendors/packages/bookings/cancel/",
    bookingdetail: (id) => `/vendors/packages/package/bookings/${id}/`,
    dashboard: "/vendors/packages/package/dashboard/",
    bookingoverview: "/vendors/packages/package/bookings/overview/",
  },
};

export default endpoints;
